// src/components/Layout.js
import { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const nav = [
  { to: '/dashboard', icon: '⬛', label: 'Dashboard' },
  { to: '/admins',    icon: '🔑', label: 'Admins' },
  { to: '/users',     icon: '👥', label: 'Users' },
  { to: '/staff',     icon: '🪪', label: 'Staff' },
  { to: '/live-trains',    icon: '🚂', label: 'Train Tracker' },
  { to: '/all-trains', icon: '📊', label: 'All Trains' },
];

export default function Layout({ children }) {
  const { admin, logout } = useAuth();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);

  const doLogout = async () => { await logout(); navigate('/login'); };

  const sw = collapsed ? 56 : 260;

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#1a1a1a' }}>
      {/* Sidebar */}
      <aside style={{
        width: sw, minWidth: sw, background: '#1e1e1e',
        borderRight: '1px solid #2a2a2a', display: 'flex',
        flexDirection: 'column', transition: 'width .2s', overflow: 'hidden',
        position: 'fixed', top: 0, left: 0, bottom: 0, zIndex: 100,
      }}>
        {/* Logo */}
        <div style={{
          padding: collapsed ? '18px 16px' : '18px 20px',
          borderBottom: '1px solid #2a2a2a', display: 'flex',
          alignItems: 'center', gap: 12, minHeight: 60,
        }}>
          <span style={{ fontSize: 22, flexShrink: 0 }}>🚂</span>
          {!collapsed && (
            <div>
              <div style={{ color: '#f0f0f1', fontWeight: 700, fontSize: 15, lineHeight: 1.2 }}>RailTrack</div>
              <div style={{ color: '#646970', fontSize: 11 }}>Admin Panel</div>
            </div>
          )}
          <button onClick={() => setCollapsed(c => !c)} style={{
            marginLeft: 'auto', background: 'none', border: 'none',
            color: '#646970', fontSize: 16, padding: 4, flexShrink: 0,
          }}>{collapsed ? '▶' : '◀'}</button>
        </div>

        {/* Nav */}
        <nav style={{ flex: 1, padding: '8px 0', overflowY: 'auto' }}>
          {nav.map(({ to, icon, label }) => (
            <NavLink key={to} to={to} style={({ isActive }) => ({
              display: 'flex', alignItems: 'center', gap: 12,
              padding: collapsed ? '10px 16px' : '10px 20px',
              color: isActive ? '#f0f0f1' : '#a7aaad',
              background: isActive ? '#2271b1' : 'transparent',
              borderLeft: isActive ? '3px solid #72aee6' : '3px solid transparent',
              fontSize: 13, fontWeight: isActive ? 600 : 400,
              transition: 'all .15s', textDecoration: 'none',
              whiteSpace: 'nowrap', overflow: 'hidden',
            })}>
              <span style={{ fontSize: 16, flexShrink: 0 }}>{icon}</span>
              {!collapsed && label}
            </NavLink>
          ))}
        </nav>

        {/* User info */}
        <div style={{
          padding: collapsed ? '12px 16px' : '12px 20px',
          borderTop: '1px solid #2a2a2a',
        }}>
          {!collapsed && (
            <div style={{ color: '#a7aaad', fontSize: 12, marginBottom: 8, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {admin?.name || admin?.email}
            </div>
          )}
          <button onClick={doLogout} style={{
            background: 'rgba(214,54,56,.1)', border: '1px solid rgba(214,54,56,.3)',
            color: '#d63638', borderRadius: 4, padding: collapsed ? '6px 8px' : '6px 12px',
            fontSize: 12, fontWeight: 600, width: '100%', cursor: 'pointer',
          }}>
            {collapsed ? '↩' : '↩ Logout'}
          </button>
        </div>
      </aside>

      {/* Main */}
      <main style={{ flex: 1, marginLeft: sw, transition: 'margin-left .2s', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        {/* Top bar */}
        <div style={{
          height: 46, background: '#232323', borderBottom: '1px solid #2a2a2a',
          display: 'flex', alignItems: 'center', padding: '0 24px',
          position: 'sticky', top: 0, zIndex: 50,
        }}>
          <div style={{ color: '#a7aaad', fontSize: 13 }}>
            🟢 <span style={{ color: '#f0f0f1', fontWeight: 600 }}>{admin?.name}</span>
            <span style={{ marginLeft: 8, color: '#646970' }}>· Admin</span>
          </div>
        </div>

        <div style={{ flex: 1, padding: 24 }}>
          {children}
        </div>
      </main>
    </div>
  );
}
